/*  ==========================================================================
    IMPRESSIONS V2
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initImpressionsV5($element) {

    // magnific popup
    utils.mfp.initGallery($element);

    // initialize slider
    let $sliderContainer = $element.find('.bn-impressions-v5__slider'),
        slidesCount = $sliderContainer.find('.bn-impressions-v5__image').length,
        sliderOverrides = {
            nextArrow: '<div class="bn-arrows__arrow bn-arrows__arrow-next"><i class="bn-icon bn-icon--pfeil_scopri"></i></div>',
            pauseOnHover: true,
            prevArrow: '<div class="bn-arrows__arrow bn-arrows__arrow-prev"><i class="bn-icon bn-icon--pfeil_scopri"></i></div>',
            slidesToShow: 1
        };
    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

    $element.find('.pagination_length').text(slidesCount);

    $sliderContainer.on('afterChange', function(event, slick, currentSlide, nextSlide) {
        $element.find('.pagination_index').text(currentSlide + 1);
    });

    $('.bn-impressions-v2__head').each(function () {
        if($(this).find('.bn-impressions-v2__title').length){
            $(this).addClass('bn-titleset');
        }
    });
}


// WEBPACK FOOTER //
// ./source/js/modules/lib/impressions-v5.js